const acentos = [
  {
    letter: 'a',
    reg: /[àáâãäå]/,
  },
  {
    letter: 'e',
    reg: /[èéêẽ]/,
  },
  {
    letter: 'o',
    reg: /[óòôõ]/,
  },
  {
    letter: 'i',
    reg: /[íìîĩ]/,
  },
  {
    letter: 'u',
    reg: /[ùúûũ]/,
  },
  {
    letter: 'c',
    reg: /[ç]/,
  },
];

export default function ReplaceAcentoFilter(text) {
  if (text) {
    if (typeof text !== 'string') {
      return text;
    }
    let overrideText = String(text).toLocaleLowerCase();
    acentos.forEach(
      (item) => {
        overrideText = overrideText.replace(item.reg, item.letter);
      },
    );
    return overrideText;
  }
  return text;
}
